import listesPaginees from '@/api/parametres/_listes-paginees.js'
import { nouvelleListe, chargerPage, rechercherDiffere, rechargerDepuisDebut } from '@/utils/liste-paginee.js'

export default {
    name: 'tarif-observation',
    components: {},
    props: {
        assurance_id: Number,
        fields: Array,
        assurance_select: Object,
        editing_observation_tarif_data: Object,
        // Section affichée par le filtre Prestation de l'en-tête
        visible: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            is_printing: false,

            // Liste paginée côté serveur
            liste: nouvelleListe(),
            // Assurance de la liste : 0 au chargement, puis l'assurance choisie dans l'en-tête
            assurance_id_liste: 0,
            page_demandee: 0,
            a_recharger: false,
        }
    },

    watch: {
        assurance_select() {
            this.assurance_id_liste = this.assurance_select.compagnie_id
            this.rechargerDepuisDebut()
        },

        // Section de nouveau affichée : rechargée si l'assurance a changé entre-temps
        visible() {
            if (this.visible && this.a_recharger) {
                this.charger()
            }
        },

        editing_observation_tarif_data() {
            this.saveTarifObservation()
        }
    },

    computed: {
        // Aucune donnée (hors recherche en cours)
        est_vide() {
            return !this.liste.chargement && !this.liste.erreur && this.liste.total == 0 && this.liste.q == ''
        },
    },

    mounted() {
        this.charger()
    },

    methods: {
        /**
         * Appel API : avec page / per_page / q => une page ; sans => la liste complète (impression)
         * @param {*} params
         */
        appel(params) {
            return listesPaginees.tarifTypesAdmission(Object.assign({
                assurance_id: this.assurance_id_liste,
                data_type: 'observation'
            }, params))
        },

        /**
         * Charge la page courante
         */
        charger() {
            this.a_recharger = false
            this.page_demandee = this.liste.page

            return chargerPage(this.liste, (params) => this.appel(params))
        },

        /**
         * Retour à la page 1 (assurance changée) ; différé au prochain affichage si la section est masquée
         */
        rechargerDepuisDebut() {
            if (this.visible) {
                rechargerDepuisDebut(this.liste, () => this.charger())
            } else {
                this.liste.page = 1
                this.page_demandee = 1
                this.a_recharger = true
            }
        },

        /**
         * Pagination (@input) : charge la page choisie (ignore la remise à 1 faite par le rechargement)
         */
        changerPage() {
            if (this.liste.page != this.page_demandee) {
                this.charger()
            }
        },

        rechercher() {
            rechercherDiffere(this.liste, () => this.charger())
        },

        edit(data, type_prestation) {
            const tarif_data = {
                data: data,
                type_prestation: type_prestation
            }
            this.$emit('emitTarifObservation', tarif_data)
        },

        saveTarifObservation() {
            this.editing_observation_tarif_data.type_prestation = 'observation'
            this.$store.dispatch("saveTarifTypeAdmission", this.editing_observation_tarif_data).then((response) => {
                if (response.success) {
                    // Page courante rechargée
                    this.charger()

                    this.$emit('emitCloseTarifModal')
                } else {
                    if (response.code == 401) {
                        this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard.")
                    } else if (response.code == 500) {
                        this.errorToast("Une erreur s'est produite !")
                    }
                }
                this.save_loading = false
                this.btn_disable = false
            })
        },

        /**
         * Impression : liste complète (sans pagination)
         */
        printTarifObservation() {
            if (this.is_printing) {
                return
            }
            this.is_printing = true

            this.appel({}).then((reponse) => {
                const data = {
                    data_type: 'observation',
                    prestations: Array.isArray(reponse) ? reponse : ((reponse && Array.isArray(reponse.data)) ? reponse.data : [])
                }

                this.$emit('emitPrintTarif', data)
            }).catch(() => {
                this.errorToast("Une erreur s'est produite lors du chargement de la liste à imprimer !")
            }).finally(() => {
                this.is_printing = false
            })
        }
    }
}
